/**
 * @file     presaleFlow.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for the presale ask on the /presales pages: what
 *           the buyer wants to know, use and timing, capture, confirmation.
 */
export const presaleFlow = {
  actions: { continue: 'Continue' },
  questions: {
    title: 'What do you want to know?',
    label: 'Questions',
    deposit: 'Deposit schedule',
    completion: 'Completion details',
    floorPlans: 'Floor plans and pricing',
    developer: "The developer's record",
  },
  plans: { title: 'How and when?' },
  use: { label: 'Use', liveIn: 'To live in', investment: 'As an investment', notSure: 'Not sure yet' },
  timeline: { label: 'Timing', soon: 'In the next 3 months', year: 'In 3 to 12 months', researching: 'Just researching' },
  capture: {
    title: 'Where should Ray reach you?',
    submit: 'Send',
  },
  confirmation: {
    title: 'Request received',
    body: 'Confirm your email, then Relta Real Estate will reach out.',
  },
};
